import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { useField } from 'formik';
import React__default from 'react';
import { Checkbox } from './Checkbox.js';
var CheckboxField = React__default.forwardRef(function (props, ref) {
  var field = useField(__assign(__assign({}, props), {
    type: "checkbox"
  }))[0];
  var fieldOnChange = field.onChange,
    fieldOnBlur = field.onBlur;
  var onChange = props.onChange,
    onBlur = props.onBlur;
  var handleChange = React__default.useCallback(function (e) {
    fieldOnChange(e);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [fieldOnChange, onChange]);
  var handleBlur = React__default.useCallback(function (e) {
    fieldOnBlur(e);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }, [fieldOnBlur, onBlur]);
  return React__default.createElement(Checkbox, __assign({}, field, props, {
    onChange: handleChange,
    onBlur: handleBlur,
    ref: ref
  }));
});
export { CheckboxField };